import { validateRow } from './schema_validator'

function normalizeColumnName (name) {
  return name.toLowerCase().replace(/[-_\s]+/g, '').trim()
}

export function autoMapColumns (sourceColumns, schema) {
  const mapping = {}
  const matched = []
  const targetNames = schema.columns.map((column) => column.name)
  const normalizedTargets = new Map()

  schema.columns.forEach((column) => {
    normalizedTargets.set(normalizeColumnName(column.name), column.name)
  })

  sourceColumns.forEach((sourceCol) => {
    const targetCol = normalizedTargets.get(normalizeColumnName(sourceCol))

    if (targetCol) {
      mapping[sourceCol] = targetCol
      matched.push(targetCol)
    }
  })

  const missing = targetNames.filter((target) => !matched.includes(target))
  const extra = sourceColumns.filter((source) => !mapping[source])

  let status
  if (missing.length === 0) status = 'perfect'
  else if (matched.length > 0) status = 'partial'
  else status = 'none'

  return { status, matched, missing, extra, mapping }
}

function dataUsesSchemaColumns (data, schema) {
  if (data.length === 0) return false

  const row = data[0]
  return schema.columns.every((column) => Object.hasOwn(row, column.name))
}

export function validateMappedRows (data, schema) {
  const errors = new Map()
  const transformedData = []
  const validRows = []
  const errorRows = []

  data.forEach((row, index) => {
    const rowIndex = typeof row.__rowIndex === 'number' ? row.__rowIndex : index
    const newRow = { __rowIndex: rowIndex }

    schema.columns.forEach((column) => {
      const value = row[column.name]

      if (value !== undefined && value !== null && value !== '') {
        newRow[column.name] = value
      } else if (column.defaultValue !== undefined) {
        newRow[column.name] = column.defaultValue
      } else {
        newRow[column.name] = ''
      }
    })

    const validation = validateRow(newRow, schema, rowIndex)

    if (validation.hasError) {
      errors.set(rowIndex, validation.errors)
      newRow.__hasError = true
      errorRows.push(newRow)
    } else {
      validRows.push(newRow)
    }

    transformedData.push(newRow)
  })

  return {
    data: transformedData,
    validRows,
    errorRows,
    errors,
    stats: { total: data.length, valid: validRows.length, invalid: errorRows.length }
  }
}

export function applyMapping (data, mapping, schema) {
  if (dataUsesSchemaColumns(data, schema)) return validateMappedRows(data, schema)

  const errors = new Map()
  const transformedData = []
  const validRows = []
  const errorRows = []
  const reverseMapping = new Map()

  Object.entries(mapping).forEach(([source, target]) => {
    if (target) reverseMapping.set(target, source)
  })

  data.forEach((row, index) => {
    const rowIndex = typeof row.__rowIndex === 'number' ? row.__rowIndex : index
    const newRow = { __rowIndex: rowIndex }

    schema.columns.forEach((column) => {
      const sourceCol = reverseMapping.get(column.name)

      if (sourceCol && row[sourceCol] !== undefined && row[sourceCol] !== '') {
        newRow[column.name] = row[sourceCol]
      } else if (column.defaultValue !== undefined) {
        newRow[column.name] = column.defaultValue
      } else {
        newRow[column.name] = ''
      }
    })

    const validation = validateRow(newRow, schema, rowIndex)

    if (validation.hasError) {
      errors.set(rowIndex, validation.errors)
      newRow.__hasError = true
      errorRows.push(newRow)
    } else {
      validRows.push(newRow)
    }

    transformedData.push(newRow)
  })

  return {
    data: transformedData,
    validRows,
    errorRows,
    errors,
    stats: { total: data.length, valid: validRows.length, invalid: errorRows.length }
  }
}
